/* global I18n */
import Tooltip from 'rc-tooltip'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Spinner from 'lib/tags/spinner'
import post from 'lib/utils/post'

const TranslateDetails = ({ scope }) => {
  const [details, setDetails] = useState(null)

  useEffect(() => {
    ;(async () => {
      try {
        const response = await post('/utils/site_translation_details', { key: scope })
        setDetails(response.details)
      } catch (error) {
        console.error('Error loading details:', error)
      }
    })()
  }, [scope])

  if (!details) {
    return <Spinner />
  }

  return (
    <table className='i18n-table'>
      <tbody>
        {details.map(locale => (
          <tr key={locale.locale} className={locale.locale === I18n.locale ? 'selected' : ''}>
            <td>{locale.locale}</td>
            <td>{locale.content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

const Translate = ({ scope, options }) => {
  return (
    <Tooltip
      placement='bottom'
      trigger={['hover']}
      overlay={
        <div className='i18n-tooltip'>
          <div>
            <a
              href={`https://www.apprentus.com/admin/site_translations?path=${scope}`}
              target='_blank'
              rel='noreferrer'
            >
              {scope}
            </a>
          </div>
          <TranslateDetails scope={scope} />
        </div>
      }
    >
      <span className={`i18n-dev-string${window.__missingKeys && window.__missingKeys[scope] ? ' missing' : ''}`}>
        {I18n.t(scope, options)}
      </span>
    </Tooltip>
  )
}

TranslateDetails.propTypes = {
  scope: PropTypes.string
}

Translate.propTypes = {
  scope: PropTypes.string,
  options: PropTypes.object
}

export default Translate
